import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as model from "../../../models";

@Component({
	selector: 'distribution-channels-presentation',
	templateUrl: "./distribution-channels.presentation.html",
	styles: [require("./distribution-channels.presentation.scss")]
})
export class DistributionChannelsPresentation {
	@Input() set event( event: model.Event) {
		this._event = event;
		if(!this.event) {
			this.distributionChannelsForm = null;
		}
		if (this._event) {
			this.releaseToggleButtonText = this._event.releasedForDistribution ? 'Sperren' : 'Freigeben';
		}
		if (this._event && this._distributionChannels) {
			this.distributionChannelsForm = this.createForm(this._distributionChannels, this._event)
		}
	}

	@Input() set distributionChannels(distributionChannels: string[]){
		this._distributionChannels = distributionChannels;
		if (this._distributionChannels && this._event) {
			this.distributionChannelsForm = this.createForm(this._distributionChannels, this._event);
		}
	}

	@Output() private saveDisabledDistributionChannels = new EventEmitter<string[]>();
	@Output() private toggleEventReleasedClicked = new EventEmitter<boolean>();


	private distributionChannelsForm: FormGroup;
	private _event: model.Event;
	private _distributionChannels: string[];
	private releaseToggleButtonText: string;

	protected submitForm(distributionChannelsFormData) {
		const disabledDistributionChannels: string[] = this._distributionChannels
					.filter(distributionChannel => !distributionChannelsFormData[distributionChannel]);
					this.saveDisabledDistributionChannels.emit(disabledDistributionChannels);
	}

	private createForm(distributionChannels: string[], event: model.Event): FormGroup  {
		const controls: {[key: string]: FormControl} = distributionChannels
			.map( dC => ({name: dC, control: new FormControl(event.disabledDistributionChannels ? !(event.disabledDistributionChannels.indexOf(dC)>=0) : true)}))
			.reduce(
				(result, item) => {
					result[item.name] = item.control
					return result;
				},
				<{[key: string]: FormControl}>{}
			)
		return new FormGroup(controls);
	}

	private selectAll() {
		for (let dc of this._distributionChannels) {
			this.distributionChannelsForm.controls[dc].setValue(true);
		}
	}

	private deselectAll() {
		for (let dc of this._distributionChannels) {
			this.distributionChannelsForm.controls[dc].setValue(false);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/distribution-channels/distribution-channels.presentation.ts